import React from 'react'
import Typography from '@ntuctech/devex-tangram/Typography'

import Panel from '../Panel/Panel'

const Error = ({ error }) => {
  return (
    <Panel shadow css="justify-content: center">
      <Typography variant="body2">
        Something went wrong while contacting the server. Please try again
        later.
      </Typography>
      <Typography variant="body2">Error: {error.message}</Typography>
    </Panel>
  )
}

export default Error
